{
  "appType": "aaas",
  "assetsUrl": "https://stage-dashboard-3as.va-endpoint.com/",
  "standaloneBaseUrl": "https://stage-dashboard.va-endpoint.com",
  "translationsUrl": "https://stage-cdn.va-endpoint.com/translations/dashboard",
  "announcementModalApiUrl": "https://www.twipla.com/api/v1/inapp/bubbles/index.php",
  "announcementBannerApiUrl": "https://www.twipla.com/api/v1/inapp/banners/index.php",
  "dashboardTilesApiUrl": "https://www.twipla.com/api/v1/inapp/tiles/",
  "wixAppId": "93b481a9-c2dd-4b00-9ff4-48f0b6bfb9c2",
  "dashboardWebsiteId": "d73f91db-b653-11f1-bdcf-faa48035f77b",
  "workerEnv": "stage",
  "wixBaseUrl": "https://stage-wix-dashboard.va-endpoint.com/",
  "apiUrl": "https://stage-api.va-endpoint.com/api",
  "aiApiUrl": "https://stage-ai.va-endpoint.com",
  "gatewayApiUrl": "https://stage-api-gateway.va-endpoint.com",
  "paddleVendorId": 4891,
  "paddleSandbox": true,
  "wixIgnoreVisitsUrl": "https://stage-loadbalancer.va-endpoint.com/worker-messages",
  "reCaptchaSiteKey": "6Lez-tkUAAAAAEh8Pn3-ikUmU6p2svEXN-LCl2iY",
  "statsOverviewReleaseDate": 1577836800,
  "chatwootToken": "6PKafZ6wwTAdrR3FgDUzxnq3",
  "env": "prod",
  "surveysUrl": "https://stage-surveys-app.va-endpoint.com",
  "firstPromoter": {
    "apiUrl": null,
    "apiKey": null,
    "wId": null
  },
  "competitionReleaseDate": 1596319200,
  "supportedLanguages": [
    "en",
    "de",
    "es",
    "pt",
    "it",
    "fr",
    "ro"
  ],
  "customDomain": ".stage.va-endpoint.com",
  "maintenancePeriods": [
    [
      "2024-12-06T03:30:00.000Z",
      "2024-12-06T05:30:00.000Z"
    ],
    [
      "2024-11-06T03:30:00.000Z",
      "2024-11-06T05:30:00.000Z"
    ]
  ],
  "flagSmithEnvironmentId": "VfTtYXGtTh7upYJxvMJtAX",
  "sentryDsn": "https://38dc1a994a42cfb9f8e479ca26a80439@sentry.visitor-analytics.io/2",
  "sentryAuthToken": "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",
  "sourceTag": "master-970"
}
